"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const client_1 = __importDefault(require("react-dom/client"));
const App_1 = __importDefault(require("./App"));
const Global_1 = __importDefault(require("./styles/Global"));
require("./styles/global.css");
const rootNode = document.getElementById('root');
client_1.default.createRoot(rootNode).render((0, jsx_runtime_1.jsxs)(react_1.default.StrictMode, { children: [(0, jsx_runtime_1.jsx)(Global_1.default, {}), (0, jsx_runtime_1.jsx)(App_1.default, {})] }));
